<ng-container *ngIf="templateContext$ | async as content">
  <div class="checkout-content-b2bUnits">
    <div class="checkout-content-warning">
      <strong class="checkout-content-warning-title">{{ 'checkout.review.message.title' | translate }}</strong>
      <span class="checkout-content-warning-description">{{ 'checkout.review.message.desc' | translate }}</span>
    </div>

    @if (content.isEmpty) {
      <p class="no-b2bUnits">{{ 'cart.empty' | translate }}</p>
    } @else {
      <cart-furnisher [disabledItems]="true" />
    }
  </div>
</ng-container>
